import { render, staticRenderFns } from "./banner_galery.vue?vue&type=template&id=724f6c92&"
import script from "./banner_galery.vue?vue&type=script&lang=js&"
export * from "./banner_galery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports